var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-grey-stripo"},[_c('PopUpPreview',{ref:"previewPopup",attrs:{"htmlContent":_vm.emailHtml,"isPdpa":_vm.pdpaEmail}}),_c('div',{attrs:{"id":"stripoSettingsContainer"}},[_vm._v("Loading...")]),_c('div',{attrs:{"id":"stripoPreviewContainer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }